import * as CreDtos from "../CRE.dtos";

export const
    PUBLICATIONS_REQUEST = "PUBLICATIONS_REQUEST",
    PUBLICATIONS_REQUEST_FAILURE = "PUBLICATIONS_REQUEST_FAILURE",
    PUBLICATIONS_REQUEST_SUCCESS = "PUBLICATIONS_REQUEST_SUCCESS",
    PUBLICATIONS_FILTER = "PUBLICATION_FILTER",
    PUBLICATION_ADD = "PUBLICATION_ADD",
    PUBLICATION_EDIT = "PUBLICATION_EDIT",
    PUBLICATION_CANCEL = "PUBLICATION_CANCEL",
    PUBLICATION_UPSERT_REQUEST = "PUBLICATION_UPSERT_REQUEST",
    PUBLICATION_UPSERT_REQUEST_FAILURE = "PUBLICATION_UPSERT_REQUEST_FAILURE",
    PUBLICATION_UPSERT_REQUEST_SUCCESS = "PUBLICATION_UPSERT_REQUEST_SUCCESS"

export function publicationsRequest() {
    return {
        type: PUBLICATIONS_REQUEST
    };
}

export function publicationsRequestSuccess(publications: CreDtos.Publication[], focus: CreDtos.Focus[], states: CreDtos.State[], publicationTypes: CreDtos.PublicationType[], people: CreDtos.People[]) {
    return {
        type: PUBLICATIONS_REQUEST_SUCCESS,
        publications,
        focus,
        states,
        publicationTypes,
        people
    };
}

export function publicationsRequestFailure(error) {
    return {
        type: PUBLICATIONS_REQUEST_FAILURE,
        error
    };
}

export function publicationsFilter(search: string, showDisabled: boolean, publicationTypeId: number, showResource: number) {
    return {
        type: PUBLICATIONS_FILTER,
        search,
        showDisabled,
        publicationTypeId,
        showResource
    }
}

export function publicationAdd() {
    return {
        type: PUBLICATION_ADD
    }
}

export function publicationEdit(publication: CreDtos.Publication) {
    return {
        type: PUBLICATION_EDIT,
        publication
    }
}

export function publicationCancel() {
    return {
        type: PUBLICATION_CANCEL
    }
}

export function publicationUpsertRequest(publication: CreDtos.Publication) {
    return {
        type: PUBLICATION_UPSERT_REQUEST,
        publication
    };
}

export function publicationUpsertRequestSuccess(publication: CreDtos.Publication) {
    return {
        type: PUBLICATION_UPSERT_REQUEST_SUCCESS,
        publication
    };
}

export function publicationUpsertRequestFailure(error) {
    return {
        type: PUBLICATION_UPSERT_REQUEST_FAILURE,
        error
    };
}




// WEBPACK FOOTER //
// ./src/actions/publications.actions.ts